import { BaseModel } from './BaseModel';

export class Activity extends BaseModel {
  static get entity() {
    return 'activities';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      files: this.attr(null),
      attachments: this.attr(null),
      activityContent: this.attr(null),
      lecture: this.attr(null),
      type: this.attr(null),
      isWatched: this.attr(null),
      video_link_vimeo: this.attr(null),
      duration: this.attr(0),
      transcode_status: this.attr(null),
      upload_status: this.attr(null),
      thumbnail_link: this.attr(null),
      order: this.attr(null),
      created_at: this.attr(null),
      updated_At: this.attr(null),
      delete_at: this.attr(null),
      displayed: this.attr(null),
      description: this.attr(null),
      start_at: this.attr(null),
      start_after: this.attr(null),
      start_after_hour: this.attr(null),
      start_after_minute: this.attr(null),
      start_after_ampm: this.attr(null)
    };
  }

  // student query
  static getLecturesOnlyRenderBySectionId(section_id) {
    return this.query().orderBy('order').where('displayed', true).where('section_id', section_id);
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get(`/activities`);
      },
      fetchBySectionId(section_id) {
        return this.get(`/activities`, {
          params: {
            section: section_id
          }
        });
      },
      fetchById(id) {
        return this.get(`/activities`, id);
      },
      createActivity(lecture, section_id = 3, video_link_vimeo) {
        let data = {
          name: lecture,
          section: section_id,
          video_link_vimeo
        };
        return this.post(`/activities`, data);
      },
      uploadFilesAttachment(formData) {
        return this.post(`/upload`, formData, {
          onUploadProgress: (e) => Math.round((e.loaded * 100) / e.total)
        });
      },
      deleteFilesAttachment(id) {
        return this.delete(`/upload/files/${id}`);
      },
      deletedFileUploadFileMorph(id) {
        return this.delete(`activities/files/${id}`);
      },
      updateActivity(id, data) {
        return this.put(`/activities/${id}`, data);
      },
      updateIsWatched(id) {
        const isWatched = true;
        return this.put(`/activities/${id}`, {
          isWatched
        });
      },
      getVimeoUploadLink(size) {
        return this.get(`/activities/vimeo`, {
          params: {
            size
          }
        });
      },
      addVimeoVideoToFolderAndConfig(video_id, activity_id) {
        return this.get(`/activities/vimeo/folder`, {
          params: {
            video_id,
            activity_id
          }
        });
      },
      vimeoCheckTranscodeStatus(video_id, activity_id) {
        return this.get(`/activities/vimeo/transcode`, {
          params: {
            video_id,
            activity_id
          }
        });
      },
      deleteActivity(activity_id) {
        return this.delete(`activities/${activity_id}`);
      },

      /**
       * Create activity with attacment by one request
       * @param {Object} activityData object of activity model
       * @param {Number[]} fileIds array of file's ids from uploading files
       */
      createWithAttachment(activityData, fileIds) {
        console.log(activityData);
        return this.post(`activities/create-with-attachments`, {
          activityData,
          fileIds
        });
      },

      /**
       * Update activity with attachment by one request
       * @param {Number} activityId activity's id
       * @param {Object} data data for updating activity & attachment
       * @param {Object} data.activityData data for updating activity
       * @param {Number[]} data.fileIdsToAdd new files' id
       * @param {Number[]} data.fileIdsToDelete files' id for deleting
       */
      updateWithAttachment(activityId, data) {
        return this.put(`activities/update-with-attachments/${activityId}`, data);
      },

      /**
       * update delete_at in activity table from `null` to `CURRENT_TIMESTAMP`
       * @param {Object} data
       * @param {Number[]} data.ids ids that you want to delete ex. ids: [2, 4, 5]
       */
      softDelete(data) {
        console.log('Activity softDelete data : ', data);
        return this.post(`/activities/soft-delete`, data);
      },

      /**
       * Create relation between an activity and files in attachment table
       * @param {Object[]} data multiple relation
       * @param {Number} data.activity activity's id
       * @param {Number} data.file file's id
       */
      createAttachment(data) {
        console.log('Attachment relation data : ', data);
        return this.post(`/attachments`, data);
      },

      /**
       * update delete_at in attachment table from `null` to `CURRENT_TIMESTAMP`
       * @param {Number[]} data ids of attachment
       */
      softDeleteAttachment(data) {
        console.log('Attachment softDelete data : ', data);
        return this.post(`/attachments/soft-delete`, data);
      }
    }
  };
}

export default Activity;
